export const defaultTheme = {
  primaryColor: "#ffffff",
  secondaryColor: "#28A3A9",
  iconFillColor: "#28A3A9",
  sidebarInnerHEadingColor: "gray;",
  sidebarInnnerDivBg: "#ffff",
  tableRowBg: "whitesmoke",
  tableRowColor: "#000",
  activeButtonBg: "#1fc91ffa",
  landingOutletBg: "rgba(20, 93, 160, 0.09)",
  inputBg: "#fff",
  inputColor: "#000",
  fontFamily: "Poppins",
  sidebarheadingcolor: "rgba(0, 0, 0, 0.6)",
  sidebarclickheadingcolor: "#fff",
};

export const nightMode = {
  primaryColor: "#ffffff",
  secondaryColor: "#28A3A9",
  iconFillColor: "#28A3A9",
  sidebarInnerHEadingColor: "gray;",
  sidebarInnnerDivBg: "#212121",
  tableRowBg: "#212121",
  tableRowColor: "#fff",
  activeButtonBg: "#1fc91ffa",
  landingOutletBg: "#000",
  inputBg: "#fff",
  inputColor: "#000",
  fontFamily: "Poppins",
  sidebarheadingcolor: "#fff",
  sidebarclickheadingcolor: "#fff",
};

export const debounce = (func, timeOut = 400) => {
  let timer;
  return (...args) => {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, timeOut);
  };
};
